exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".set-rating__wrapper-2bgvMK{display:flex}.set-rating__wrapper-2bgvMK .star-3bWuVC+.star-3bWuVC{margin-left:5px}", ""]);
